"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterNone;
function filterNone(pxData, pxPos, byteWidth, rawData, rawPos) {
  pxData.copy(rawData, rawPos, pxPos, pxPos + byteWidth);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/filter/pack/filterNone.js
// module id = 1077
// module chunks = 0